export const NEXT_LOCALE_COOKIE = 'NEXT_LOCALE';
export const NEXT_THEME_COOKIE = 'NEXT_THEME';
export const NEXT_COLOR_SCHEME_COOKIE = 'NEXT_COLOR_SCHEME';
export const NEXT_AGE_GATE_COOKIE = 'NEXT_AGE_GATE';
export const NEXT_AGE_GATE_SERVER_COOKIE = 'NEXT_AGE_GATE_SERVER';
